import { ConversationsService } from './../services/conversations.service';
import { MenuService } from './../services/menu.service';
import { Component, OnInit } from '@angular/core';

import '../../assets/js/scripts.js';
declare var Project: any;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit {

  public contracts;
  public servers;
  public domains;
  public clouds;
  public backupftps;
  public cloudvps;
  public serversColocated;
  public filteredServers;
  public filteredContracts;
  public filteredDomains;
  public filteredServersColocated;
  public filteredClouds;
  public filteredBackupftps;
  public filteredCloudvps;

  public loadingMenu = true;

  constructor(
    private menuService: MenuService,
    private conversationsService: ConversationsService
  ) { 
  }

  ngOnInit() {
    this.menuService.getMenuStructure().subscribe((menu) => {
      this.contracts = menu.contracts;
      this.filteredServers = menu.servers;
      this.filteredContracts = menu.contracts;
      this.filteredDomains = menu.domains;
      this.servers = menu.servers;
      this.domains = menu.domains;
      this.clouds = menu.clouds;
      this.backupftps = menu.backup_ftp;
      this.filteredClouds = menu.clouds;
      // console.log(this.clouds);
      this.serversColocated = menu.servers_colocated;
      this.filteredServersColocated = menu.servers_colocated;
      
      this.filteredBackupftps = menu.backup_ftp;
      this.filteredCloudvps = menu.cloud_vps;
      this.cloudvps = menu.cloud_vps;

      //console.log(this.filteredServers);
      this.loadingMenu = false;
    });

    // this.conversationsService.getOpenConversationsCount().subscribe(count => this.openConversations = count);
  }

  search(val: any) {
    this.filteredServers = this.searchItems(val, this.servers, 'name');
  }

  searchBackupFtps(val: any) {
    this.filteredBackupftps = this.searchItems(val, this.backupftps, 'name');
  }

  searchClouds(val: any) {
    this.filteredClouds = this.searchItems(val, this.clouds, 'name');
  }

  searchCloudVPS(val: any) {
    this.filteredCloudvps = this.searchItems(val, this.cloudvps, 'name');
  }

  searchServersColocated(val: any) {
    this.filteredServersColocated = this.searchItems(val, this.serversColocated, 'name');
  }

  searchContract(val: any) {
    this.filteredContracts = this.searchItems(val, this.contracts, 'name');
  }

  searchDomains(val: any) {
    this.filteredDomains = this.searchItems(val, this.domains, 'name');
  }

  searchItems(val: any, searchIn, searchBy) {
    if(val == ''){
      return searchIn;
    }
    const regex = new RegExp(val, 'i');
    let searched = searchIn.filter(item => {
      return item[searchBy].match(regex);
    });
    return searched;
  }

  ngAfterContentChecked() {
    Project.menu();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/menu.component.ts